export default __webpack_public_path__ + "static/media/Goal_Tracking.6777cecb.png";